import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { Link,useHistory } from "react-router-dom";
import swal from 'sweetalert';
// import Loader from '../../layout/loader';
import axios from "axios";
import { SAVE_BANK_ACCOUNT_DETAILS_RESET } from '../../redux/constants/refundConstant';
import { saveBankAccountDetailsAction, clearErrorAction } from '../../redux/actions/refundAction';



import './addBankAccount.css'

function AddBankAccountDetails() {

    const dispatch = useDispatch();
    const history = useHistory();

// saving bank account info 
    const { saved, loading, error } = useSelector((state) => state.saveAccount)

    // user details
    const { user } = useSelector((state) => state.user)

    const [name, setName] = useState('');
    const [stateName, setStateName] = useState('');
    const [bankName, setBankName] = useState('');
    const [fullBankName, setFullBankName] = useState('');
    const [bankAddress, setBankAddress] = useState('');
    const [branchName, setBranchName] = useState('');
    const [bankCityName, setBankCityName] = useState('');
    const [bankIfscCode, setBankIfscCode] = useState('');
    const [bankContactNumber, setBankContactNumber] = useState('');
    const [bankAccountNumber, setBankAccountNumber] = useState('');
    const [confirmBankAccountNumber, setConfirmBankAccountNumber] = useState('');

    const bankNameData = [
        "ABHYUDAYA CO-OP BANK LTD",
        " ABU DHABI COMMERCIAL BANK",
        "AKOLA DISTRICT CENTRAL CO-OPERATIVE BANK",
        "AKOLA JANATA COMMERCIAL COOPERATIVE BANK",
        "ALLAHABAD BANK",
        "ALMORA URBAN CO-OPERATIVE BANK LTD.",
        "ANDHRA BANK",
        "ANDHRA PRAGATHI GRAMEENA BANK",
        "APNA SAHAKARI BANK LTD",
        "AUSTRALIA AND NEW ZEALAND BANKING GROUP LIMITED.",
        "AXIS BANK",
        "BANK INTERNASIONAL INDONESIA",
        "BANK OF AMERICA",
        "BANK OF BAHRAIN AND KUWAIT",
        " BANK OF BARODA",
        " BANK OF CEYLON",
        "BANK OF INDIA",
        "BANK OF MAHARASHTRA",
        " BANK OF TOKYO-MITSUBISHI UFJ LTD.",
        "BARCLAYS BANK PLC",
        "BASSEIN CATHOLIC CO-OP BANK LTD",
        " BHARATIYA MAHILA BANK LIMITED",
        " BNP PARIBAS",
        "CALYON BANK",
        " CANARA BANK",
        "CAPITAL LOCAL AREA BANK LTD.",
        "CATHOLIC SYRIAN BANK LTD.",
        " CENTRAL BANK OF INDIA",
        "CHINATRUST COMMERCIAL BANK",
        "CITIBANK NA",
        "CITIZENCREDIT CO-OPERATIVE BANK LTD",
        "CITY UNION BANK LTD",
        "COMMONWEALTH BANK OF AUSTRALIA",
        " CORPORATION BANK",
        " CREDIT SUISSE AG",
        "DBS BANK LTD",
        "DENA BANK",
        "DEUTSCHE BANK",
        " DEUTSCHE SECURITIES INDIA PRIVATE LIMITED",
        "DEVELOPMENT CREDIT BANK LIMITED",
        "DHANLAXMI BANK LTD",
        "DICGC",
        "DOMBIVLI NAGARI SAHAKARI BANK LIMITED",
        " FIRSTRAND BANK LIMITED",
        "GOPINATH PATIL PARSIK JANATA SAHAKARI BANK LTD",
        "GURGAON GRAMIN BANK",
        "HDFC BANK LTD",
        "HSBC",
        "ICICI BANK LTD",
        "IDBI BANK LTD",
        "IDRBT",
        "INDIAN BANK",
        "INDIAN OVERSEAS BANK",
        "INDUSIND BANK LTD",
        "INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED",
        "ING VYSYA BANK LTD",
        "JALGAON JANATA SAHKARI BANK LTD",
        "JANAKALYAN SAHAKARI BANK LTD",
        "JANASEVA SAHAKARI BANK (BORIVLI) LTD",
        " JANASEVA SAHAKARI BANK LTD. PUNE",
        "JANATA SAHAKARI BANK LTD (PUNE)",
        "JPMORGAN CHASE BANK N.A",
        "KALLAPPANNA AWADE ICH JANATA S BANK",
        "KAPOL CO OP BANK",
        "KARNATAKA BANK LTD",
        "KARNATAKA VIKAS GRAMEENA BANK",
        "KARUR VYSYA BANK",
        "KOTAK MAHINDRA BANK",
        "KURMANCHAL NAGAR SAHKARI BANK LTD",
        "MAHANAGAR CO-OP BANK LTD",
        "MAHARASHTRA STATE CO OPERATIVE BANK",
        "MASHREQBANK PSC",
        "MIZUHO CORPORATE BANK LTD",
        "MUMBAI DISTRICT CENTRAL CO-OP. BANK LTD.",
        "NAGPUR NAGRIK SAHAKARI BANK LTD",
        "NATIONAL AUSTRALIA BANK",
        "NEW INDIA CO-OPERATIVE BANK LTD.",
        "NKGSB CO-OP BANK LTD",
        " NORTH MALABAR GRAMIN BANK",
        " NUTAN NAGARIK SAHAKARI BANK LTD",
        "OMAN INTERNATIONAL BANK SAOG",
        " ORIENTAL BANK OF COMMERCE",
        "PARSIK JANATA SAHAKARI BANK LTD",
        " PRATHAMA BANK",
        "PRIME CO OPERATIVE BANK LTD",
        " PUNJAB AND MAHARASHTRA CO-OP BANK LTD.",
        "PUNJAB AND SIND BANK",
        "PUNJAB NATIONAL BANK",
        "RABOBANK INTERNATIONAL (CCRB)",
        "RAJGURUNAGAR SAHAKARI BANK LTD.",
        " RAJKOT NAGARIK SAHAKARI BANK LTD",
        "RESERVE BANK OF INDIA",
        "SBERBANK",
        "SHINHAN BANK",
        "SHRI CHHATRAPATI RAJARSHI SHAHU URBAN CO-OP BANK LTD",
        "SOCIETE GENERALE",
        "SOLAPUR JANATA SAHKARI BANK LTD.SOLAPUR",
        "SOUTH INDIAN BANK",
        "STANDARD CHARTERED BANK",
        "STATE BANK OF BIKANER AND JAIPUR",
        "STATE BANK OF HYDERABAD",
        "STATE BANK OF INDIA",
        "STATE BANK OF MAURITIUS LTD",
        "STATE BANK OF MYSORE",
        "STATE BANK OF PATIALA",
        "STATE BANK OF TRAVANCORE",
        "SUMITOMO MITSUI BANKING CORPORATION",
        " SYNDICATE BANK",
        "TAMILNAD MERCANTILE BANK LTD",
        "THANE BHARAT SAHAKARI BANK LTD",
        "THE A.P. MAHESH CO-OP URBAN BANK LTD.",
        "THE AHMEDABAD MERCANTILE CO-OPERATIVE BANK LTD.",
        " THE ANDHRA PRADESH STATE COOP BANK LTD",
        "THE BANK OF NOVA SCOTIA",
        "THE BANK OF RAJASTHAN LTD",
        "THE BHARAT CO-OPERATIVE BANK (MUMBAI) LTD",
        "THE COSMOS CO-OPERATIVE BANK LTD.",
        "THE DELHI STATE COOPERATIVE BANK LTD.",
        "THE FEDERAL BANK LTD",
        "THE GADCHIROLI DISTRICT CENTRAL COOPERATIVE BANK LTD",
        "THE GREATER BOMBAY CO-OP. BANK LTD",
        "THE GUJARAT STATE CO-OPERATIVE BANK LTD",
        " THE JALGAON PEOPLES CO-OP BANK",
        "THE JAMMU AND KASHMIR BANK LTD",
        "THE KALUPUR COMMERCIAL CO. OP. BANK LTD.",
        "THE KALYAN JANATA SAHAKARI BANK LTD.",
        "THE KANGRA CENTRAL CO-OPERATIVE BANK LTD",
        "THE KANGRA COOPERATIVE BANK LTD",
        "THE KARAD URBAN CO-OP BANK LTD",
        "THE KARNATAKA STATE APEX COOP. BANK LTD.",
        "THE LAKSHMI VILAS BANK LTD",
        " THE MEHSANA URBAN COOPERATIVE BANK LTD",
        " THE MUNICIPAL CO OPERATIVE BANK LTD MUMBAI",
        "THE NAINITAL BANK LIMITED",
        " THE NASIK MERCHANTS CO-OP BANK LTD., NASHIK",
        "THE RAJASTHAN STATE COOPERATIVE BANK LTD.",
        "THE RATNAKAR BANK LTD",
        " THE ROYAL BANK OF SCOTLAND N.V",
        "THE SAHEBRAO DESHMUKH CO-OP. BANK LTD.",
        "THE SARASWAT CO-OPERATIVE BANK LTD",
        "THE SEVA VIKAS CO-OPERATIVE BANK LTD (SVB)",
        "THE SHAMRAO VITHAL CO-OPERATIVE BANK LTD",
        "THE SURAT DISTRICT CO OPERATIVE BANK LTD.",
        "THE SURAT PEOPLES CO-OP BANK LTD",
        "THE SUTEX CO.OP. BANK LTD.",
        "THE TAMILNADU STATE APEX COOPERATIVE BANK LIMITED",
        "THE THANE DISTRICT CENTRAL CO-OP BANK LTD",
        "THE THANE JANATA SAHAKARI BANK LTD",
        "THE VARACHHA CO-OP. BANK LTD.",
        "THE VISHWESHWAR SAHAKARI BANK LTD.,PUNE",
        "THE WEST BENGAL STATE COOPERATIVE BANK LTD",
        "TJSB SAHAKARI BANK LTD.",
        "TUMKUR GRAIN MERCHANTS COOPERATIVE BANK LTD.,",
        "UBS AG",
        "UCO BANK",
        "UNION BANK OF INDIA",
        "UNITED BANK OF INDIA",
        " UNITED OVERSEAS BANK",
        "VASAI VIKAS SAHAKARI BANK LTD.",
        "VIJAYA BANK",
        "WEST BENGAL STATE COOPERATIVE BANK",
        " WESTPAC BANKING CORPORATION",
        "WOORI BANK",
        " YES BANK LTD",
        "ZILA SAHKARI BANK LTD GHAZIABAD ",
    ];

    useEffect(() => {

        if (error) {
            swal({
                title: "Error",
                text: error,
                icon: "error",
            })
            dispatch(clearErrorAction())
        }

        if (saved) {
            swal({
                title: "Success",
                text: saved,
                icon: "success",
            })
            dispatch({ type: SAVE_BANK_ACCOUNT_DETAILS_RESET })
            history.push('/userprofile');
        }

        if (loading) {
            swal("Please Wait....", {
                button: false,
            });
        }

    }, [loading, error, saved, history,dispatch])



    const getBankIfscDetails = async (e) => {
        e.preventDefault()

        try {

            const { data } = await axios.get(`https://ifsc.razorpay.com/${bankIfscCode}`);
            setBankName(data.BANK);
            setBankAddress(data.ADDRESS);
            setBankCityName(data.CITY);
            setBranchName(data.BRANCH);
            setStateName(data.DISTRICT);
            setBankContactNumber(data.CONTACT)

        } catch (error) {
            swal({
                title: "Validation Error",
                text: error.response.data,
                icon: "info",
                button: "OK",
            });
        }

    }

    const savingBankHandler = (e) => {
        e.preventDefault()
        dispatch(saveBankAccountDetailsAction(name, user.email, bankIfscCode, stateName, bankName, bankAddress, branchName, bankCityName, bankContactNumber, bankAccountNumber, confirmBankAccountNumber, fullBankName))
    }



    return (
        <Fragment>
            <div className="main-heading-add-your-account-details">
                <h2 className="main-heading-h2">
                    Add your bank account detail's for refund
                </h2>
            </div>

            <form className="refund-main-form-container" onSubmit={savingBankHandler}>
                <label>
                    Please Enter Name as Per Passbook
                    <div>
                        <input placeholder="Enter Your Full Name" value={name} onChange={(e) => setName(e.target.value)} />
                    </div>
                </label>

                <label>
                    Please Select Bank
                    <select onChange={(e) => setFullBankName(e.target.value)}>
                        {bankNameData.map((bank) => (
                            <option value={bank}> {bank}</option>
                        ))}
                    </select>
                </label>

                <label>
                    Bank Account Number
                    <div>
                        <input type='password' placeholder="account name should match with name" value={bankAccountNumber} onChange={(e) => setBankAccountNumber(e.target.value)} />
                    </div>

                </label>

                <label>
                    Confirm Account Number
                    <div>
                        <input type='number' placeholder="please add carefully" value={confirmBankAccountNumber} onChange={(e) => setConfirmBankAccountNumber(e.target.value)} />
                    </div>

                </label>

                <div className="infs-code-container">
                    Bank Ifsc Code :
                    <div className="main-ifsc-container">
                        <div>
                            <input type="text" placeholder="ABC0000050000" value={bankIfscCode} onChange={(e) => setBankIfscCode(e.target.value)} />
                        </div>
                        <div>
                            <button onClick={getBankIfscDetails} > Find  </button>
                        </div>
                    </div>

                    <span>  {bankAddress} <span>{branchName} {bankCityName} {stateName} </span>  <span> {bankContactNumber}</span> </span>
                </div>
                <div className="add-bank-account-terms-and-conditions-div">
                    <input type='checkbox' />
                    <p> I Accpet all<Link to="/about/return-and-exchange"  > terms & conditions    </Link> of IM Online Shopping Co.  </p>
                </div>


                <button className="refund-details-submit-button" >
                    Submit
                </button>
            </form>
        </Fragment>
    );
}

export default AddBankAccountDetails;
